import { useState } from "react";
import { FaChevronDown, FaClock } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import {
  InstallationPickerOption,
  InstallationPickerSheet,
} from "../installation/InstallationPickerSheet";
import {
  NOTIFICATION_PERIOD_OPTIONS,
  setNotificationPeriodHours,
} from "./notificationPeriodUtils";

const NotificationPeriodPicker = ({ value, onChange, disabled = false }) => {
  const { t } = useTranslation();
  const [sheetOpen, setSheetOpen] = useState(false);

  const handleSelect = (hours) => {
    setNotificationPeriodHours(hours);
    onChange(hours);
    setSheetOpen(false);
  };

  return (
    <>
      <button
        type="button"
        className="notifications-list-period-trigger installation-list-toggle"
        onClick={() => setSheetOpen(true)}
        disabled={disabled}
        aria-haspopup="dialog"
        aria-expanded={sheetOpen}
        aria-label={t("mobile_notifications_period_sheet_title")}
      >
        <FaClock
          className="notifications-list-period-trigger-icon"
          aria-hidden
        />
        <span>
          {t("mobile_notifications_period_trigger", { hours: value })}
        </span>
        <FaChevronDown
          className="notifications-list-period-trigger-chevron"
          aria-hidden
        />
      </button>

      <InstallationPickerSheet
        open={sheetOpen}
        title={t("mobile_notifications_period_sheet_title")}
        onDismiss={() => setSheetOpen(false)}
      >
        {NOTIFICATION_PERIOD_OPTIONS.map((hours) => (
          <InstallationPickerOption
            key={hours}
            label={t("mobile_notifications_period_option", { hours })}
            selected={value === hours}
            onSelect={() => handleSelect(hours)}
          />
        ))}
      </InstallationPickerSheet>
    </>
  );
};

export default NotificationPeriodPicker;
